import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialLaboratoryDepartmentState: Dtos.LaboratoryDepartment & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    pathologyDepartmentId: null,
    pathologyDepartment: null,
    expiryDate: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ILaboratoryDepartmentReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    pathologyDepartmentId:IFieldState<number>,
    expiryDate: IFieldState<string>,
    active: IFieldState<boolean>,
    dateInactive: IFieldState<string>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>
}
